import React, { useCallback, useLayoutEffect, useMemo, useRef, useState, } from 'react';
import { useSharedValue } from 'react-native-reanimated';
import StatusBar from 'design-system/StatusBar';
import { AppView, NavigationHeader } from 'design-system';
import EmptyComponent from 'design-system/EmptyComponent';
import useColors from 'hooks/useColors';
import { setTransactionFilters } from 'actions/deviceSettings';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { selectTransactionFilterAccounts } from 'reducers/selectors';
import TransactionsList from '../components/TransactionsList';
import { normalizeSelectedAccounts } from '../utils/accountFilter';
import TransactionsHeader from '../components/TransactionsHeader';
import TxnScreenNavHeaderExtension from '../components/TxnScreenNavHeaderExtension';
export const DEFAULT_FILTERS = {
    selectedAccountsObj: {},
    showExcludedTxns: true,
};
const TransactionsScreen = ({ navigation, route, }) => {
    const { from, to } = route.params || {};
    const transactionsListRef = useRef(null);
    const dispatch = useAppDispatch();
    const scrollY = useSharedValue(0);
    const userFilters = useAppSelector((state) => state.deviceSettings.transactionFilters);
    const filterAccounts = useAppSelector(selectTransactionFilterAccounts);
    const paramsFilters = typeof route.params?.filters === 'object'
        ? route.params?.filters
        : undefined;
    const [filters, setFilters] = useState(paramsFilters || userFilters || DEFAULT_FILTERS);
    const colors = useColors();
    useLayoutEffect(() => {
        navigation.setOptions({
            title: 'Transactions',
            headerTitle: EmptyComponent,
            headerTintColor: colors.elements.primary,
            headerRight: () => (<TransactionsHeader showExport onPressEdit={transactionsListRef.current?.onEdit} isEditing={route.params?.isEditing} from={from} to={to} filters={filters}/>),
        });
    }, [
        colors.background.light,
        colors.elements.primary,
        filters,
        from,
        route.params?.isEditing,
        to,
    ]);
    const onScrollY = useCallback((scrollYValue = 0) => {
        scrollY.value = scrollYValue;
    }, [scrollY]);
    const setTxnFilters = useCallback((selectedAccountsObj, showExcludedTxns) => {
        const newFilters = {
            showExcludedTxns,
            selectedAccountsObj,
        };
        dispatch(setTransactionFilters(newFilters));
        setFilters(newFilters);
    }, [dispatch]);
    const accountIdsStr = useMemo(() => {
        const accountIds = Object.keys(normalizeSelectedAccounts(filters.selectedAccountsObj, filterAccounts));
        if (!accountIds.length) {
            return undefined;
        }
        const numberAccIds = accountIds.map((accountIdStr) => Number(accountIdStr));
        numberAccIds.sort();
        let accountIdsStr = '';
        numberAccIds.forEach((numberAccId) => {
            accountIdsStr += `accountIds[]=${numberAccId}&`;
        }, []);
        return accountIdsStr;
    }, [filterAccounts, filters.selectedAccountsObj]);
    return (<AppView withFrame={false}>
      <StatusBar barStyle="dark-content" animated/>
      <NavigationHeader scrollY={scrollY} title="Transactions">
        <TxnScreenNavHeaderExtension scrollY={scrollY} filters={filters} setFilters={setTxnFilters} showHiddenSection/>
      </NavigationHeader>
      <TransactionsList to={to} from={from} onScrollY={onScrollY} navigation={navigation} ref={transactionsListRef} accountIdsStr={accountIdsStr} showExcludedTransactions={filters.showExcludedTxns} reducedTopPadding/>
    </AppView>);
};
export default TransactionsScreen;
